'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { useTalkToSalesCta } from '#pplx/frontend/apps/ask/talk-to-sales/useTalkToSalesCta.js';
import { Link } from '#pplx/frontend/router/Link.js';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
const FOOTER_MESSAGES = defineMessages({
    orgCreditPurchaseModal: {
        defaultMessage: 'For custom pricing, <link>contact sales</link>',
        description: 'Footer note in the org credit purchase modal offering custom pricing through sales',
        id: 'a86e68937f',
    },
    paywallFooter: {
        defaultMessage: 'For additional enterprise features and custom pricing, <link>contact sales</link>',
        description: 'Footer note below the paywall plan cards offering custom pricing through sales',
        id: '1175c2acc9',
    },
});
/**
 * Small footer-text talk-to-sales CTA. Self-gates on eligibility (flag,
 * audience targeting, enterprise consent) and renders nothing when ineligible,
 * so mount points stay one-line insertions with no conditional logic.
 */
export const TalkToSalesFooterNote = ({ surface }) => {
    const cta = useTalkToSalesCta(surface);
    if (!cta) {
        return null;
    }
    return (_jsx(TextPrimitive, { variant: "small", color: "light", children: _jsx(FormattedMessage, { ...FOOTER_MESSAGES[surface], values: {
                link: (chunks) => (_jsx(Link, { href: cta.href, className: "underline", target: "_blank", rel: "noopener noreferrer", onClick: cta.open, children: chunks })),
            } }) }));
};
//# sourceMappingURL=TalkToSalesFooterNote.js.map